import server from "../../../../server";
import dayjs,{Dayjs} from "dayjs";


export async function getEmployeeSummary(empId: string, year: number) {
    const res = await server.attendance.employee.getAttendanceSummary(empId, year);
    return res;

}

export async function getAttendanceCount(date: string) {
    const res = await server.attendance.admin.count(date);
    return res;
}


export async function getEmployeesAttendanceList(page:number,size:number,startDate?:string,endDate?:string) {
    const res =await server.attendance.admin.list(page,size,startDate,endDate);
    return res;
}

export async function getAttendanceList(employeeId:string,page:number,size:number,startDate?:string,endDate?:string) {
    const res =await server.attendance.employee.list(employeeId,page,size,startDate,endDate);
}

export function getFormattedDate(date?:Dayjs) {
    if(date)
   return dayjs(date).format('YYYY-MM-DD');
    //return today date
    return dayjs().format('YYYY-MM-DD');
}
